import * as JSONMapper from "json-mapper";
import {JSONMapped, jsonProperty} from "json-mapper-reflect";
import {AvdbPricingDeviceBundle} from "./avdb-pricing-device-bundle";
import {AvdbPricingProductType} from "./avdb-pricing-product-type";

export class AvdbPricingDevice extends JSONMapped() {
	@jsonProperty()
	modelID: number;

	@jsonProperty()
	id: number;

	@jsonProperty()
	name: string;

	@jsonProperty()
	serial: number;

	@jsonProperty()
	displaySerial: string;

	@jsonProperty(JSONMapper.arrayOfClass(AvdbPricingDeviceBundle))
	bundles: Array<AvdbPricingDeviceBundle>;

	@jsonProperty(JSONMapper.arrayOfClass(AvdbPricingProductType))
	avdbProductTypes: Array<AvdbPricingProductType>;

	constructor(data?: Partial<AvdbPricingDevice>) {
		super();
		Object.assign(this, data);
	}

	get allProducts() {
		return [].concat(...this.avdbProductTypes.map(t => t.products));
	}
}
